import React from 'react';
import { ChevronDown, ChevronUp, Upload, Camera, FileText, X } from 'lucide-react';
import Button from '../../../components/ui/Button';

const EvidenceUpload = ({ expanded, onToggle, formData, setFormData }) => {
  const handleFileUpload = (type, event) => {
    const files = Array.from(event?.target?.files);
    const fileData = files?.map(file => ({
      name: file?.name,
      size: file?.size,
      type: file?.type,
      key: Date.now() + Math.random()
    }));

    if (type === 'document') {
      setFormData(prev => ({
        ...prev,
        documents: [...prev?.documents, ...fileData]
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        photos: [...prev?.photos, ...fileData]
      }));
    }
  };

  const removeFile = (type, key) => {
    if (type === 'document') {
      setFormData(prev => ({
        ...prev,
        documents: prev?.documents?.filter(d => d?.key !== key)
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        photos: prev?.photos?.filter(p => p?.key !== key)
      }));
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-50"
        onClick={onToggle}
      >
        <div className="flex items-center gap-3">
          <Upload className="w-5 h-5 text-blue-600" />
          <h2 className="text-lg font-semibold text-gray-900">Evidence & Documentation</h2>
        </div>
        {expanded ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
      </div>
      {expanded && (
        <div className="p-4 pt-0 border-t border-gray-200">
          <div className="space-y-6">
            {/* Photo Upload */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Photos
              </label>
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
                <Camera className="w-12 h-12 text-gray-400 mx-auto mb-3" />
                <p className="text-sm text-gray-600 mb-3">
                  Upload photos of the incident scene, equipment, injuries, etc.
                </p>
                <input
                  type="file"
                  multiple
                  accept="image/*"
                  onChange={(e) => handleFileUpload('photo', e)}
                  className="hidden"
                  id="photo-upload"
                />
                <label htmlFor="photo-upload">
                  <Button
                    type="button"
                    variant="outline"
                    className="cursor-pointer"
                    onClick={(e) => {
                      e?.preventDefault();
                      document.getElementById('photo-upload')?.click();
                    }}
                  >
                    Select Photos
                  </Button>
                </label>
              </div>

              {formData?.photos?.length > 0 && (
                <div className="mt-3 space-y-2">
                  {formData?.photos?.map((photo) => (
                    <div 
                      key={photo?.key}
                      className="flex items-center justify-between bg-gray-50 rounded p-2"
                    >
                      <div className="flex items-center gap-2">
                        <Camera className="w-4 h-4 text-gray-600" />
                        <span className="text-sm text-gray-900">{photo?.name}</span>
                      </div>
                      <button
                        type="button"
                        onClick={() => removeFile('photo', photo?.key)}
                        className="text-red-600 hover:text-red-800"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Document Upload */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Documents
              </label>
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
                <FileText className="w-12 h-12 text-gray-400 mx-auto mb-3" />
                <p className="text-sm text-gray-600 mb-3">
                  Upload related documents, procedures, maintenance records, etc.
                </p>
                <input
                  type="file"
                  multiple
                  accept=".pdf,.doc,.docx,.xls,.xlsx"
                  onChange={(e) => handleFileUpload('document', e)}
                  className="hidden"
                  id="document-upload"
                />
                <label htmlFor="document-upload">
                  <Button
                    type="button"
                    variant="outline"
                    className="cursor-pointer"
                    onClick={(e) => {
                      e?.preventDefault();
                      document.getElementById('document-upload')?.click();
                    }}
                  >
                    Select Documents
                  </Button>
                </label>
              </div>

              {formData?.documents?.length > 0 && (
                <div className="mt-3 space-y-2">
                  {formData?.documents?.map((doc) => (
                    <div 
                      key={doc?.key}
                      className="flex items-center justify-between bg-gray-50 rounded p-2"
                    >
                      <div className="flex items-center gap-2">
                        <FileText className="w-4 h-4 text-gray-600" />
                        <span className="text-sm text-gray-900">{doc?.name}</span>
                      </div>
                      <button
                        type="button"
                        onClick={() => removeFile('document', doc?.key)}
                        className="text-red-600 hover:text-red-800"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EvidenceUpload;